module.exports = __webpack_public_path__ + "img/cave.c246e067.png";